export default "__VITE_ASSET__LnqIbE5M__"